"use client";

import { EyeOff, Lock, ShieldCheck, CircleUser as UserCircle } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Mission() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = [{
    icon: ShieldCheck,
    title: "Simple hygiene",
    description: "We make maintaining cleanliness feel effortless and approachable for every family."
  }, {
    icon: Lock,
    title: "Peace of mind",
    description: "Feel confident and prepared for every interaction, wherever your day takes you."
  }, {
    icon: EyeOff,
    title: "Portable design",
    description: "Compact and convenient, our mist fits perfectly into your modern, busy lifestyle."
  }, {
    icon: UserCircle,
    title: "Trusted care",
    description: "Designed for parents, travelers, and caregivers who prioritize health and safety."
  }];
  return <section data-section-id="16278" id="our-mission-vision" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div ref={headRef} className="lg:col-span-5 transition-all duration-700 ease-out" style={{
          opacity: headVisible ? 1 : 0,
          transform: headVisible ? "translateY(0)" : "translateY(16px)"
        }}>
            <h1 className="font-serif font-normal text-foreground leading-[1.02]" style={{
            fontSize: "clamp(2.75rem, 6.5vw, 5.5rem)",
            letterSpacing: "-0.02em"
          }}>
              Prepared for{" "}
              <em className="font-serif not-italic" style={{
              fontStyle: "italic",
              color: "var(--primary)"
            }}>
                peace
              </em>{" "}
              of mind.
            </h1>
            <p className="mt-6 max-w-md font-default font-normal text-foreground leading-[1.55]" style={{
            fontSize: "clamp(1.0625rem, 1.25vw, 1.25rem)",
            letterSpacing: "-0.005em"
          }}>
              B.Y.E. Hygiene Mist™ is built to be your trusted companion, 
              helping families and travelers maintain simple, convenient 
              hygiene habits before you enter any space.
            </p>
          </div>

          {}
          <div ref={gridRef} className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature, i) => {
            const Icon = feature.icon;
            return <div data-index={i} key={i} className="group bg-card rounded-lg p-6 md:p-7 shadow-md hover:shadow-lg transition-all duration-[320ms] ease-out hover:-translate-y-1" style={{
              opacity: gridVisible ? 1 : 0,
              transform: gridVisible ? "translateY(0)" : "translateY(16px)",
              transitionDelay: gridVisible ? `${i * 80}ms` : "0ms",
              transitionProperty: "opacity, transform, box-shadow",
              transitionDuration: "600ms",
              transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
            }}>
                  <div className="flex items-center justify-center rounded-lg" style={{
                width: "40px",
                height: "40px",
                backgroundColor: "var(--accent)",
                borderRadius: "9999px"
              }}>
                    <Icon size={22} strokeWidth={1.75} className="text-accent-foreground" />
                  </div>
                  <h3 className="mt-5 font-default font-semibold text-foreground" style={{
                fontSize: "clamp(1.0625rem, 1.3vw, 1.25rem)",
                letterSpacing: "-0.005em",
                lineHeight: 1.35
              }}>
                    {feature.title}
                  </h3>
                  <p className="mt-2 font-default text-foreground" style={{
                fontSize: "clamp(0.9375rem, 1vw, 1rem)",
                lineHeight: 1.6
              }}>
                    {feature.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}